module.exports = __webpack_public_path__ + "img/pintrest.de2c3326.svg";